<template>
  <section id="values" class="fade-in section">
    <h2>{{ $t('values.title') }}</h2>
    <div class="values-grid">
      <div class="value-card" v-for="(item, i) in values" :key="i">
        <div class="value-icon"><i :class="item.icon"></i></div>
        <h3>{{ $t(item.title) }}</h3>
        <p>{{ $t(item.text) }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ValuesSection',
  data() {
    return {
      values: [
        { icon: 'fas fa-check-circle', title: 'values.cards.quality.title', text: 'values.cards.quality.text' },
        { icon: 'fas fa-lightbulb', title: 'values.cards.creativity.title', text: 'values.cards.creativity.text' },
        { icon: 'fas fa-clock', title: 'values.cards.time.title', text: 'values.cards.time.text' },
        { icon: 'fas fa-smile', title: 'values.cards.satisfaction.title', text: 'values.cards.satisfaction.text' }
      ]
    };
  }
};
</script>

<style scoped>
</style>
